var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-content"},[_c('img',{staticClass:"s",attrs:{"src":_vm.imageSUrl}}),_c('img',{staticClass:"m",attrs:{"src":_vm.imageMUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }